import React from 'react'
import { PlayCircleFillIcon } from 'client/icons'

export const Thumb = props => {
  const { selected, onClick, img, type } = props

  return (
    <div className={'embla-thumbs__slide'.concat(selected ? ' embla-thumbs__slide--selected' : '')} onClick={onClick}>
      {type === 'VIDEO' && <PlayCircleFillIcon className='play' />}
      <img src={img} alt='' />
    </div>
  )
}
